import type HotelRoomType from './HotelRoomType';

export type CountedRoomType = { count: number; room: HotelRoomType };
export default class RoomsPackage {
    private readonly _roomsList: HotelRoomType[];
    constructor({ rooms }: { rooms: HotelRoomType[] }) {
        this._roomsList = rooms;
    }

    get id(): string {
        return this.roomTypeList.reduce((id, curr) => id + curr.id, '');
    }

    get roomsList(): CountedRoomType[] {
        return this._roomsList.reduce((list, curr) => {
            const prev = list.find(i => i.room.id === curr.id);
            if (prev) {
                prev.count++;
                return list;
            } else {
                list.push({ count: 1, room: curr });
                return list;
            }
        }, [] as CountedRoomType[]);
    }

    get roomTypeList(): HotelRoomType[] {
        return this.roomsList.map(v => v.room);
    }

    get payablePrice(): number {
        return this.roomsList.reduce(
            (total, curr) =>
                total + (curr.room.cheapestPriceClass?.singlePayable ?? 0),
            0
        );
    }
}
